import debug from 'debug';
import { throttle, isString, set, get } from 'lodash';
const log = debug('itp:core:object-store');
export class ObjectStore {
    name;
    data;
    saveData;
    constructor(name) {
        this.name = 'object-store:' + name;
        this.saveData = throttle(this._saveData, 1000);
        this.data = this.loadData() || {};
    }
    async get(key, source = 'local') {
        return await this.getLocal(key);
    }
    async set(key, value, dest = 'local') {
        return await this.setLocal(key, value);
    }
    async getLocal(key) {
        const result = localStorage.getItem(key);
        if (isString(result)) {
            if (result === 'undefined') {
                return;
            }
            return JSON.parse(result);
        }
    }
    async setLocal(key, value) {
        log('setLocal - key=%s, value=%o', key, value);
        localStorage.setItem(key, JSON.stringify(value));
        return value;
    }
    setItem(path, value) {
        log('setItem - path=%s, value=%o', path, value);
        set(this.data, path, value);
        this.saveData();
    }
    getItem(path, defaultValue) {
        let result = get(this.data, path, defaultValue);
        if (result === 'undefined') {
            result = defaultValue;
        }
        log('getItem - path=%s, result=%o', path, result);
        return result;
    }
    loadData() {
        const result = localStorage.getItem(this.name);
        if (isString(result)) {
            return JSON.parse(result);
        }
    }
    _saveData() {
        localStorage.setItem(this.name, JSON.stringify(this.data));
    }
}
//# sourceMappingURL=object-store.js.map